module.exports = __webpack_public_path__ + "static/arrow-1-747662d1b4a199580ea94a9d6b8a57a5.svg";